import { Button, Form, Input, Rate, Space } from "antd";
import { useState } from "react";
import { useRatingCreation } from "../../api/Ratings";

const UserRatingForm = ({ userId, onFinish }) => {
  const [submitting, setSubmitting] = useState(false);
  const createRating = useRatingCreation(userId);
  const submit = async (data) => {
    setSubmitting(true);
    createRating.mutateAsync(data).then(() => {
      onFinish && onFinish();
    });
  };
  return (
    <Form onFinish={(values) => submit(values)} layout="vertical">
      <Form.Item name="Review" label="Review">
        <Input.TextArea rows={5} />
      </Form.Item>
      <Form.Item name="Rating" label="Rating">
        <Rate />
      </Form.Item>
      <Form.Item>
        <Space>
          <Button
            type="text"
            onClick={() => onFinish && onFinish()}
            disabled={submitting}
          >
            Cancel
          </Button>
          <Button htmlType="submit" type="primary" disabled={submitting}>
            Submit
          </Button>
        </Space>
      </Form.Item>
    </Form>
  );
};

export default UserRatingForm;
